module.exports = __webpack_public_path__ + "img/noGoods.6439aee6.png";